import { createApp } from 'vue'

import PublicDataForm from '@/src/javascripts/public_data/PublicDataForm.vue'
import BaseAlert from '@/src/vueComponent/BaseAlert.vue'

$(document).on('turbo:load turbo:render', () => {
  const publicDataForm = document.querySelector('#public-data-form')
  if (publicDataForm && !publicDataForm.__vue_app__) {
    createApp({ components: { PublicDataForm, BaseAlert } }).mount(publicDataForm)
  }
})
